<template>
  <authorization permissionKey="attendance_medical_record" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Relatórios
        </v-col>

        <authorization
          permissionKey="attendance_medical_record"
          can="save"
          v-slot:default="{ authorization }"
        >
          <v-col cols="auto" v-if="authorization">
            <v-btn
              color="light-blue"
              @click="newMedicalReport"
              :dark="!attendanceEsigned"
              :disabled="attendanceEsigned"
            >
              Adicionar
            </v-btn>
          </v-col>
        </authorization>
      </v-row>

      <v-row>
        <v-col>
          <MedicalReportList
            :attendance="attendance"
            :allowEdit="!attendanceEsigned"
            :allowDelete="!attendanceEsigned"
          />
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import MedicalReportList from "@/components/medical_record/medical_report/list/index.vue";

  export default {
    name: "MedicalReport",
    components: {
      MedicalReportList,
    },
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
    },
    methods: {
      newMedicalReport() {
        this.apolloMutate({
          mutation: require("@/graphql/medical_report/save_medical_report.gql"),
          variables: {
            attendanceId: this.attendance.id,
          },
        }).then(({ data }) => {
          this.$router.push(
            `/prontuario/${this.attendance.id}/relatorio/${data.saveMedicalReport.id}`
          );
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
